import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <p>&copy; {currentYear} TopElectrónica - Electrónica Médica. Todos los derechos reservados.</p>
        <p>Especialistas en mantenimiento de equipo hospitalario y venta de insumos médicos</p>
      </div>
    </footer>
  );
};

export default Footer;
